import * as React from 'react';

import { SelectedMessage } from 'components/FileUploader';

export type UploadVideoStepSelectedMessageProps = {
  additionalMessage?: React.ReactNode;
};

const UploadVideoStepSelectedMessage: React.FC<UploadVideoStepSelectedMessageProps> = ({
  additionalMessage = 'Please select a language and continue.',
  children,
}) => (
  <SelectedMessage fileType="video" additionalMessage={additionalMessage}>
    {children}
  </SelectedMessage>
);

export default UploadVideoStepSelectedMessage;
